import React from 'react';

function Education() {
    return (
        <div className='container mt-5s'>
            <div className='row mt-5'>
                <div className='col-6'>
                    <img src='media/education.svg' alt='education'/>

                </div>
                <div className='col-6 mt-5'>
                    <h1> Free and open market education</h1>
                    <p>Varsity, the largest online stock market education book in the world covering everything from the basics to advanced trading.</p>
                    <a href="" className="mx-5" style={{ textDecoration: "none" }}>Varsity<i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>

                    <p className='mt-5'>TradingQ&A, the most active trading and investment community in India for all your market related queries.</p>
                    <a href="" className="mx-5" style={{ textDecoration: "none" }}>TradingQ&A<i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>

                </div>
            </div>

        </div>
   
     );
}

export default Education;